export default __webpack_public_path__ + "assets/img/Segoe UI Bold.21ecd6932d8c6e2ae14e071a3306b449.woff";